import React, { useState, useEffect } from 'react';
import { Award, X, Sparkles } from 'lucide-react';

const BadgeCelebration = ({ badges, onClose }) => {
    const [currentBadgeIndex, setCurrentBadgeIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (badges && badges.length > 0) {
            setIsVisible(true);
        }
    }, [badges]);

    if (!badges || badges.length === 0 || !isVisible) return null;

    const currentBadge = badges[currentBadgeIndex];
    const isLast = currentBadgeIndex === badges.length - 1;

    const handleNext = () => {
        if (isLast) {
            setIsVisible(false);
            if (onClose) onClose();
        } else {
            setCurrentBadgeIndex(prev => prev + 1);
        }
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="relative w-full max-w-md bg-gradient-to-b from-gray-900 to-black border-2 border-yellow-500/50 rounded-2xl p-8 shadow-[0_0_50px_rgba(234,179,8,0.3)] flex flex-col items-center text-center animate-in zoom-in-95 duration-300">

                {/* Close button */}
                <button
                    onClick={() => {
                        setIsVisible(false);
                        if (onClose) onClose();
                    }}
                    className="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors"
                >
                    <X size={24} />
                </button>

                {/* Celebration Header */}
                <div className="mb-6">
                    <h2 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-yellow-500 to-yellow-300 animate-pulse">
                        BADGE UNLOCKED!
                    </h2>
                    <div className="flex justify-center gap-2 mt-2 text-yellow-500/80">
                        <Sparkles size={20} className="animate-ping" />
                        <Sparkles size={20} className="animate-spin" style={{ animationDuration: '3s' }} />
                        <Sparkles size={20} className="animate-ping" style={{ animationDelay: '0.5s' }} />
                    </div>
                </div>

                {/* Badge Icon/Image */}
                <div className="relative mb-8 group cursor-pointer perspective-1000">
                    <div className="w-40 h-40 bg-gradient-to-tr from-yellow-600 to-yellow-900 rounded-full flex items-center justify-center shadow-[0_0_30px_#ca8a04] border-4 border-yellow-400/30 group-hover:scale-110 transition-transform duration-500">
                        {currentBadge.icon_url ? (
                            <img src={currentBadge.icon_url} alt={currentBadge.name} className="w-24 h-24 object-contain" />
                        ) : (
                            <Award size={80} className="text-yellow-200 drop-shadow-[0_0_15px_rgba(255,255,255,0.5)]" />
                        )}
                    </div>
                    <div className="absolute -inset-4 bg-yellow-500/20 rounded-full blur-xl -z-10 animate-pulse"></div>
                </div>

                {/* Badge Details */}
                <h3 className="text-2xl font-bold text-white mb-2">{currentBadge.name}</h3>
                <p className="text-gray-300 mb-8">{currentBadge.description}</p>

                {/* Footer/Action */}
                <button
                    onClick={handleNext}
                    className="px-8 py-3 bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-500 hover:to-yellow-400 text-black font-bold text-lg rounded-full shadow-[0_0_20px_rgba(234,179,8,0.4)] hover:shadow-[0_0_30px_rgba(234,179,8,0.6)] hover:scale-105 transition-all duration-300 transform"
                >
                    {isLast ? 'Awesome!' : 'Next Badge >'}
                </button>

                {badges.length > 1 && (
                    <div className="mt-4 text-xs text-gray-500">
                        Badge {currentBadgeIndex + 1} of {badges.length}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BadgeCelebration;
